import { lazy } from "react"
import {
    ACL_MANAGE,
    ACL_SUBJECT_SERVICE
} from "@configs/acl/constants"

const ApplicationRoutes = [
    {
        path: "/applications/application-cyber",
        component: lazy(() => import("@views/applications/applicationCyber")),
        exact: true,
        meta: {
            action: ACL_MANAGE,
            resource: ACL_SUBJECT_SERVICE
        }
    },
    {
        path: "/applications/application-other",
        component: lazy(() => import("@views/applications/applicationOther")),
        exact: true,
        meta: {
            action: ACL_MANAGE,
            resource: ACL_SUBJECT_SERVICE
        }
    }
]

export default ApplicationRoutes
